import configuration from 'configuration';

const encoder = new TextEncoder();
const AES_GCM_AUTH_TAG_LENGTH = 16;

function bytesToBase64Url(bytes) {
  let binary = '';

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
}

async function getSimulasiCryptoKey() {
  const secretBytes = encoder.encode(configuration.SIMULASI_SHARED_SECRET);
  const secretHash = await window.crypto.subtle.digest('SHA-256', secretBytes);

  return window.crypto.subtle.importKey(
    'raw',
    secretHash,
    { name: 'AES-GCM' },
    false,
    ['encrypt']
  );
}

async function encryptSimulasiToken(value) {
  const normalizedValue = `${value || ''}`.trim();

  if (!normalizedValue) {
    throw new Error('Nilai token simulasi tidak boleh kosong.');
  }

  if (!window.crypto?.subtle) {
    throw new Error('Browser tidak mendukung Web Crypto API.');
  }

  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const key = await getSimulasiCryptoKey();
  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv,
    },
    key,
    encoder.encode(normalizedValue)
  );
  const encryptedBytes = new Uint8Array(encryptedBuffer);
  const encryptedPart = encryptedBytes.slice(
    0,
    encryptedBytes.length - AES_GCM_AUTH_TAG_LENGTH
  );
  const authTagPart = encryptedBytes.slice(
    encryptedBytes.length - AES_GCM_AUTH_TAG_LENGTH
  );

  return [
    bytesToBase64Url(iv),
    bytesToBase64Url(authTagPart),
    bytesToBase64Url(encryptedPart),
  ].join('.');
}

export default encryptSimulasiToken;
